import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import useUpdateNisMachineries from '../Hooks/NisMachineriesHooks/useUpdateNisMachineries';
import adminBg from '../Assets/bg/adminbg.jpg';

const NisMachineriesEdit = ({ selectedItem, onClose, darkMode, onUpdateSuccess }) => {
  const { updateNisMachineries, loading, error } = useUpdateNisMachineries();

  const [formData, setFormData] = useState({
    years: '',
    is_name: '',
    ia_name: '',
    barangay: '',
    municipality: '',
    province: '',
    machineriesEquipment: '',
    no_unit: '',
    year_acquired: '',
    functional: '',
    not_functional: '',
    mode_acquisition: '',
    partner_shareholder: '',
    yes_Reg_num: '',
    no_Reg_num: '',
  });

  useEffect(() => {
    if (selectedItem) {
      setFormData({
        years: selectedItem.years || '',
        is_name: selectedItem.is_name || '',
        ia_name: selectedItem.ia_name || '',
        barangay: selectedItem.barangay || '',
        municipality: selectedItem.municipality || '',
        province: selectedItem.province || '',
        machineriesEquipment: selectedItem.machineriesEquipment || '',
        no_unit: selectedItem.no_unit || '',
        year_acquired: selectedItem.year_acquired || '',
        functional: selectedItem.functional || '',
        not_functional: selectedItem.not_functional || '',
        mode_acquisition: selectedItem.mode_acquisition || '',
        partner_shareholder: selectedItem.partner_shareholder || '',
        yes_Reg_num: selectedItem.yes_Reg_num || '',
        no_Reg_num: selectedItem.no_Reg_num || '',
      });
    }
  }, [selectedItem]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedItem?.id) {
      alert('Invalid machinery ID.');
      return;
    }
    const result = await updateNisMachineries(selectedItem.id, formData);
    if (result?.success) {
      onUpdateSuccess?.(result.message || 'Machinery updated successfully.');
      onClose?.();
    } else {
      alert(result?.message || 'Failed to update machinery.');
    }
  };

  const fields = [
    { key: 'machineriesEquipment', label: 'Name of Farm Machinery & Equipment' },
    { key: 'no_unit', label: 'No. of Unit' },
    { key: 'year_acquired', label: 'Year Acquired' },
    { key: 'functional', label: 'Functional' },
    { key: 'not_functional', label: 'Non Functional' },
    { key: 'mode_acquisition', label: 'Mode of Acquisition' },
    { key: 'partner_shareholder', label: 'Partner / Shareholder' },
    { key: 'yes_Reg_num', label: 'ABEMIS Reg. No. (YES)' },
    { key: 'no_Reg_num', label: 'ABEMIS (NO)' },
    { key: 'barangay', label: 'Barangay' },
    { key: 'municipality', label: 'Municipality' },
    { key: 'province', label: 'Province' },
    { key: 'is_name', label: 'IMO / System' },
    { key: 'ia_name', label: "Name of Irrigators' Association" },
    { key: 'years', label: 'Year' },
  ];

  return (
    <Panel darkMode={darkMode} show>
      <TopBar>
        <CloseBtn onClick={onClose}>&lt;</CloseBtn>
        <Title>Edit Machinery Record</Title>
        <SaveBtn type="submit" onClick={handleSubmit} disabled={loading}>
          {loading ? 'Saving...' : 'Save Changes'}
        </SaveBtn>
      </TopBar>
      <Body>
        {error && <ErrorText>{error}</ErrorText>}
        <Form onSubmit={handleSubmit}>
          {fields.map((f) => (
            <Field key={f.key}>
              <Label>{f.label}</Label>
              <Input name={f.key} value={formData[f.key]} onChange={handleChange} />
            </Field>
          ))}
        </Form>
      </Body>
    </Panel>
  );
};

export default NisMachineriesEdit;

const Panel = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  width: 80%;
  height: 100%;
  background-color: ${({ darkMode }) => (darkMode ? 'transparent' : '#f2f2f2')};
  background-image: ${({ darkMode }) => (darkMode ? `url(${adminBg})` : 'none')};
  background-size: cover;
  background-position: center;
  box-shadow: -4px 0 10px rgba(0, 0, 0, 0.2);
  transform: translateX(100%);
  transition: transform 0.5s ease;
  z-index: 2;
  padding: 20px;
  box-sizing: border-box;
  ${({ show }) => show && `transform: translateX(0);`}
`;

const TopBar = styled.div`
  position: sticky;
  top: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 5px 12px;
  z-index: 2;
`;

const CloseBtn = styled.button`
  background: none;
  border: none;
  font-size: 22px;
  cursor: pointer;
  color: #2e7d32;
`;

const Title = styled.h3`
  margin: 0;
  color: #2e7d32;
`;

const SaveBtn = styled.button`
  background-color: #2e7d32;
  color: #fff;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  &:hover { background-color: #27672a; }
  &:disabled { opacity: 0.6; cursor: not-allowed; }
`;

const Body = styled.div`
  height: calc(100% - 60px);
  overflow-y: auto;
  background: rgba(255, 255, 255, 0.92);
  border-radius: 8px;
  padding: 16px;
`;

const Form = styled.form`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px 16px;
`;

const Field = styled.div`
  display: flex;
  flex-direction: column;
`;

const Label = styled.label`
  font-size: 12px;
  margin-bottom: 4px;
  color: #555;
`;

const Input = styled.input`
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
`;

const ErrorText = styled.div`
  color: #c62828;
  font-size: 13px;
  margin-bottom: 10px;
`;
